import { NotificationIcon, SecondaryNavigationMenuItem } from "melco-ui";
import { useNotifications } from "../../hooks/notifications/useNotifications";
import isEmpty from "lodash-es/isEmpty";
import { NotificationsPopover } from "./NotificationsPopover";
import { useState } from "react";
import { notificationStatusToName } from "../../helper/notificationStatus";

export const NotificationsSecondaryNavigationMenuItem: React.FC = () => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { data } = useNotifications(popoverOpen);

  const notifications = data?.list ?? [];
  const hasNotifications = !isEmpty(notifications);
  const notificationBadge = notifications.find(
    (item) => notificationStatusToName(item.status!) === "queued"
  )
    ? "processing"
    : "default";

  return (
    <NotificationsPopover
      notifications={notifications}
      onOpenChange={(open: boolean) => setPopoverOpen(open)}
    >
      <SecondaryNavigationMenuItem
        data-cy-id="notifications-navigation-item"
        badge={hasNotifications ? notificationBadge : undefined}
      >
        <NotificationIcon />
      </SecondaryNavigationMenuItem>
    </NotificationsPopover>
  );
};
